//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('skillsCertificate', {
//        templateUrl: 'views/components/views/skillsCertificate/skillsCertificate.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'skillsCertificateService', 'typeaheadService', function ($stateParams, stateService, modalService, translateService, skillsCertificateService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let labourNo = $stateParams.labour_no;
//            let skillsCertificateKeyno = $stateParams.skillscertificate_keyno;
            
//            let translations = {
//                error: '',
//                ok: ''
//            };
            
//            vm.model = {
//                edit: {},
//                selectListSkillsCertificateTypes: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await skillsCertificateService.getSkillsCertificate({
//                    labour_no: labourNo,
//                    skillscertificate_keyno: skillsCertificateKeyno
//                }))[0];
//            }

//            async function loadSkillsCertificateTypes() {
//                vm.model.selectListSkillsCertificateTypes = await skillsCertificateService.listSkillsCertificateTypes();
//            }
            
//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearchIssuerCustomers = function (value) {
//                return typeaheadService.searchCustomer({
//                    cust_name: value || '',
//                    filtertype: '',
//                    filtervalue: '',
//                    custtype: 'S',
//                    lastselect: 'SEARCH'
//                });
//            }

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SET VALUE FUNCTION

//            vm.setIssuerCustNo = function (item) {
//                vm.model.edit.issuer_cust_no = angular.isUndefined(item) ? '0' : item.item_id;
//                vm.model.edit.issuer_cust_name = angular.isUndefined(item) ? '' : item.item_name;
//            }

//		    // #endregion SET VALUE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                skillsCertificateService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL
            
//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'documents':
//                    case 'pictures':
//                    case 'checklistdatas':
//                        skillsCertificateService.saveObj(vm.model.edit).then(function (response) {
//                            if (response[0].errorcode !== '0') {
//                                modalService.show({
//                                    type: 'warning',
//                                    title: translations.error,
//                                    message: response[0].errormessage,
//                                    buttons: [{
//                                        label: translations.ok,
//                                        cssClass: 'btn-warning',
//                                        action: function (dialogItself) {
//                                            dialogItself.close();
//                                        }
//                                    }]
//                                });
//                            } else {
//                                go({
//                                    argtype: 'skillscertificate_keyno',
//                                    argvalue: vm.model.edit.skillscertificate_keyno
//                                });
//                            }
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//                loadSkillsCertificateTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
